var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alertas),function(alerta){return _c('v-alert',{key:alerta.mensagem,attrs:{"close-text":"Close Alert","dark":"","dismissible":"","type":alerta.tipo}},[_vm._v(" "+_vm._s(alerta.mensagem)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }